<template>
  <div class="text-sm">
    <p class="mt-6">
      <b>2024.12.11</b> - Inn: upgrade/maintain peanut thresholds increased, and item
      reward scaling
    </p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>
        Balance: Fumigate AP cost increased: <code>10</code> -->
        <code>50 - L</code>
      </li>
      <li>Fixed an AI bug causing infinite loops (lock ups)</li>
      <li>AI > Interference: allow consecutive CC abilities (re-try if first fails)</li>
      <li>
        Inn
        <ul>
          <li>- Increased upgrade/maintain peanut thresholds by 50%</li>
          <li>- Fixed reward item quality scaling</li>
          <li>- Fixed a bug causing swaps to the wrong rank</li>
        </ul>
      </li>
    </ul>
  </div>
</template>
